/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import JobPositionInfo from './JobPositionInfo';

/**
 * The KanbanMoveResponse model module.
 * @module model/KanbanMoveResponse
 * @version V1
 */
class KanbanMoveResponse {
    /**
     * Constructs a new <code>KanbanMoveResponse</code>.
     * @alias module:model/KanbanMoveResponse
     */
    constructor() { 
        
        KanbanMoveResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>KanbanMoveResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/KanbanMoveResponse} obj Optional instance to populate.
     * @return {module:model/KanbanMoveResponse} The populated <code>KanbanMoveResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new KanbanMoveResponse();

            if (data.hasOwnProperty('success')) {
                obj['success'] = ApiClient.convertToType(data['success'], 'Boolean');
            }
            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('jobsAffected')) {
                obj['jobsAffected'] = ApiClient.convertToType(data['jobsAffected'], 'Number');
            }
            if (data.hasOwnProperty('updatedPositions')) {
                obj['updatedPositions'] = ApiClient.convertToType(data['updatedPositions'], [JobPositionInfo]);
            }
            if (data.hasOwnProperty('requiresRebalancing')) {
                obj['requiresRebalancing'] = ApiClient.convertToType(data['requiresRebalancing'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>KanbanMoveResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>KanbanMoveResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }
        if (data['updatedPositions']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['updatedPositions'])) {
                throw new Error("Expected the field `updatedPositions` to be an array in the JSON data but got " + data['updatedPositions']);
            }
            // validate the optional field `updatedPositions` (array)
            for (const item of data['updatedPositions']) {
                JobPositionInfo.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Boolean} success
 */
KanbanMoveResponse.prototype['success'] = undefined;

/**
 * @member {String} message
 */
KanbanMoveResponse.prototype['message'] = undefined;

/**
 * @member {Number} jobsAffected
 */
KanbanMoveResponse.prototype['jobsAffected'] = undefined;

/**
 * @member {Array.<module:model/JobPositionInfo>} updatedPositions
 */
KanbanMoveResponse.prototype['updatedPositions'] = undefined;

/**
 * @member {Boolean} requiresRebalancing
 */
KanbanMoveResponse.prototype['requiresRebalancing'] = undefined;






export default KanbanMoveResponse;

